import styled, { css } from "styled-components";
import { colors } from "../../../../styles/variables";

const priceStyles = css`
  font-size: 13px;
  color: ${colors.gray600};
`;

export const StyledPrice = styled.div`
  ${priceStyles};
`;

export const StyledOldPrice = styled.span`
  ${priceStyles};
  text-decoration: line-through;
  padding-left: 2px;
`;

export const StyledNewPrice = styled.span`
  ${priceStyles};
`;
